export const modifierList = [
  'P1A',
  'P1B',
  'P1C',
  'P2A',
  'P2B',
  'P3A',
  'P3B',
  'P3C',
  'P20A',
  'F2A',
  'F3A',
  'F3B',
  'F3C',
  'F3C',
  'F4A',
  'F4B',
  'F4C',
  'F4D',
  'F4E',
  'F4F',
  'R4A',
  'R4B',
  'R10A',
  'bg-transparent-text-dark-m',
  'bg-transparent-text-dark-t',
  'bg-transparent-text-dark-d',
  'fallback-bg-m',
  'fallback-bg-t',
  'fallback-bg-d',
  'bg-transparent-text-light-m',
  'bg-transparent-text-light-t',
  'bg-transparent-text-light-d',
  'bg-colored-m',
  'bg-colored-t',
  'bg-colored-d',
  'bg-colored-light-m',
  'bg-colored-light-t',
  'bg-colored-light-d',
  'border-m',
  'border-t',
  'border-d',
  'border-custom-m',
  'border-custom-t',
  'border-custom-d',
];
